// Helper to find closest point on a segment
import L from 'leaflet';

export const closestPointOnSegment = (point, segmentStart, segmentEnd) => {
  const x = point.lat;
  const y = point.lng;
  const x1 = segmentStart.lat;
  const y1 = segmentStart.lng;
  const x2 = segmentEnd.lat;
  const y2 = segmentEnd.lng;

  const A = x - x1;
  const B = y - y1;
  const C = x2 - x1;
  const D = y2 - y1;

  const dot = A * C + B * D;
  const len_sq = C * C + D * D;
  let param = -1;

  if (len_sq !== 0) param = dot / len_sq;

  let xx, yy;
  if (param < 0) {
    xx = x1;
    yy = y1;
  } else if (param > 1) {
    xx = x2;
    yy = y2;
  } else {
    xx = x1 + param * C;
    yy = y1 + param * D;
  }

  return L.latLng(xx, yy);
};

export const isPointNearPolyline = (point, polylineCoords, maxDistance = 50) => {
  if (!polylineCoords || polylineCoords.length < 2) return false;
  const pointLatLng = L.latLng(point);
  let minDistance = Infinity;
  for (let i = 0; i < polylineCoords.length - 1; i++) {
    const segmentStart = L.latLng(polylineCoords[i]);
    const segmentEnd = L.latLng(polylineCoords[i + 1]);
    const closest = closestPointOnSegment(pointLatLng, segmentStart, segmentEnd);
    const distance = pointLatLng.distanceTo(closest);
    if (distance < minDistance) minDistance = distance;
    if (minDistance <= maxDistance) break;
  }
  return minDistance <= maxDistance;
};

export const getSpeedLimitAtPoint = (point, tracks) => {
  for (const track of tracks) {
    if (isPointNearPolyline(point, track.coordinates, 20)) {
      return track.speedlimit;
    }
  }
  return "N/A";
};
